export const APP_META_TITLE = 'RedTab';
export const APP_META_DESCRIPTION =
  'RedTab is a modern headless commerce storefront built with Remix. It offers a fast, customizable, and scalable foundation for creating next-generation e-commerce experiences.';
export const DEMO_API_URL = 'http://localhost:3000/shop-api';
export let API_URL =
  typeof window !== 'undefined' && window.ENV?.VENDURE_API_URL
    ? window.ENV.VENDURE_API_URL
    : typeof process !== 'undefined'
      ? process.env.VENDURE_API_URL ?? DEMO_API_URL
      : DEMO_API_URL;

/**
 * This function is used when running in Cloudflare Pages in order to set the API URL
 * based on an environment variable. Env vars work differently in CF Pages and are not available
 * on the `process` object (which does not exist). Instead, it needs to be accessed from the loader
 * context, and if defined we use it here to set the API_URL var which will be used by the
 * GraphQL calls.
 *
 * See https://developers.cloudflare.com/workers/platform/environment-variables/#environmental-variables-with-module-workers
 */
export function setApiUrl(apiUrl: string) {
  API_URL = apiUrl;
}
